import { useEffect, useState } from "react";
import { updateDriverDocumentExpiry } from "../../Services/User";
import { Success, Error } from "../Modal";
import DocumentExpiryBadge from "../DocumentExpiryBadge";

const toInputDate = (value) => (value ? String(value).slice(0, 10) : "");

const FIELDS = [
  { key: "licenseExpiryDate", label: "Driving License Expiry" },
  { key: "insuranceExpiryDate", label: "Vehicle Insurance Expiry" },
  { key: "registrationExpiryDate", label: "Vehicle Registration Expiry" },
];

/**
 * Admin view/edit of a driver's document expiry dates. Expired documents block new deliveries.
 */
export default function DocumentExpiryEditor({ driver, onSaved }) {
  const vehicle = driver?.vehicle;
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValues({
      licenseExpiryDate: toInputDate(driver?.licenseExpiryDate),
      insuranceExpiryDate: toInputDate(vehicle?.insuranceExpiryDate),
      registrationExpiryDate: toInputDate(vehicle?.registrationExpiryDate),
    });
  }, [driver?.licenseExpiryDate, vehicle?.insuranceExpiryDate, vehicle?.registrationExpiryDate]);

  if (!driver?._id) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      const body = {
        licenseExpiryDate: values.licenseExpiryDate || null,
      };
      if (vehicle?._id) {
        body.insuranceExpiryDate = values.insuranceExpiryDate || null;
        body.registrationExpiryDate = values.registrationExpiryDate || null;
      }
      const res = await updateDriverDocumentExpiry(driver._id, body);
      Success("Document Expiry", res?.data?.message);
      if (onSaved) onSaved(res?.data?.data);
    } catch (err) {
      Error(err?.response?.data?.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="driver-docs-section">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
        <h4 className="driver-docs-subtitle mb-0">Document Expiry</h4>
        <DocumentExpiryBadge expiry={driver?.expiry} documentsExpired={driver?.documentsExpired} />
      </div>
      {driver?.documentsExpired ? (
        <p className="text-danger small mb-2">
          A document is expired. This driver is blocked from receiving new deliveries until the date is updated.
        </p>
      ) : null}
      <div className="row g-3 align-items-end">
        {FIELDS.map(({ key, label }) => {
          const isVehicleField = key !== "licenseExpiryDate";
          return (
            <div className="col-sm-6 col-lg-3" key={key}>
              <label className="input-lbl d-block mb-1" htmlFor={`expiry-${key}`}>{label}</label>
              <input
                id={`expiry-${key}`}
                type="date"
                className="form-control"
                value={values[key] || ""}
                disabled={isVehicleField && !vehicle?._id}
                onChange={(e) => setValues((prev) => ({ ...prev, [key]: e.target.value }))}
              />
            </div>
          );
        })}
        <div className="col-sm-6 col-lg-3">
          <button
            type="button"
            className="siteBtn header-btn-standard w-100"
            disabled={saving}
            onClick={handleSave}
          >
            {saving ? "Saving..." : "Save Dates"}
          </button>
        </div>
      </div>
    </div>
  );
}
